module.exports = __webpack_public_path__ + "static/profile-dicoding-3265bff3108150cb32f1b60a1a827d2e.jpg";